import React from "react";
import { Link } from "react-router-dom";
import { PhoneCall, ArrowRight, MessageSquare, Headphones, ShieldCheck } from "lucide-react";
import "./InfoBar.css";

const InfoBar = () => (
  <section className="infobar">
    <div className="infobar__container">
      <div className="infobar__box">
        <div className="infobar__glow" />

        <div className="infobar__content">
          <div className="infobar__badge">
            <Headphones size={13} />
            <span>Dedicated Consultation</span>
          </div>

          <h2 className="infobar__title">
            Need Guidance? Talk to an <em>AHD Property Expert</em>
          </h2>

          <p className="infobar__text">
            Have questions about market pricing, legal paperwork, home loans, or want personalized shortlist recommendations? Our certified consultants are here to guide you every step of the way.
          </p>

          <div className="infobar__trust-pills">
            <span className="infobar__trust-pill">
              <ShieldCheck size={13} /> 100% Free Consultation
            </span>
            <span className="infobar__trust-pill">
              <MessageSquare size={13} /> Quick Response
            </span>
          </div>
        </div>

        <div className="infobar__actions">
          <a href="tel:+919818961783" className="infobar__btn-phone">
            <PhoneCall size={18} strokeWidth={2.5} />
            <span>+91 9818961783</span>
          </a>

          <Link to="/contactus" className="infobar__btn-contact">
            <span>Contact Us Online</span>
            <ArrowRight size={16} strokeWidth={2.5} />
          </Link>
        </div>
      </div>
    </div>
  </section>
);

export default InfoBar;